import { render, staticRenderFns } from "./DetailInvoice.vue?vue&type=template&id=70339724&"
import script from "./DetailInvoice.vue?vue&type=script&lang=js&"
export * from "./DetailInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports